<template>
  <div class="main">
    <Sidebar
      :hide-search="true"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    >
      <div slot="header" class="sidebar-header">
        <DetailsMenu
          class="d-xl-none"
          :learning-path="learningPath"
          title="Learning Path Surveys"
          current="Surveys"
          :show-enrollment-buttons="false"
        />
      </div>
    </Sidebar>

    <DetailsMenu
      class="d-none d-xl-block pt-3"
      :learning-path="learningPath"
      title="Learning Path Surveys"
      current="Surveys"
      :show-enrollment-buttons="false"
    />

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>

          <div class="row d-none d-xl-flex">
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center text-xl-left">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mb-3 mr-sm-1 mb-sm-0 mb-xl-3"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-4 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
              >
                <template v-slot:col_created_at="{ item }">{{
                  item.created_at | moment("MM/DD/YYYY h:mma")
                }}</template>
                <template v-slot:list-menu="{ item, id }">
                  <ListMenu
                    :item="item"
                    :id="id"
                    :eventBus="listEvents"
                    @show-alert="showAlert"
                  />
                </template>
              </ListTable>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-lg-4 mb-3 mb-lg-0 text-center text-lg-left">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mb-3 mr-sm-1 mb-sm-0 mb-xl-3"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-lg-4 mb-3 mb-lg-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-lg-4 text-center text-lg-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import DetailsMenu from "./partials/DetailsMenu";
import ListMenu from "../surveys/partials/SubmissionListMenu";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: { DetailsMenu, ListMenu },
  props: {
    learningPath: { type: Object, required: true },
  },
};
</script>
